<template>
  <b-modal
    v-model="isOpen"
    scrollable
    centered
    :title="title"
    size="lg"
    @hidden="onClose"
    @ok="onClose"
  >
    <div
      style="min-height: 300px;"
      class="pb-5"
    >
      <div class="mb-2">
        <div class="small font-weight-bold mb-1">
          Инициатор
        </div>
        <b-select
          v-model="$v.selectedInitiators.$model"
          value-field="id"
          text-field="name"
          :options="initiators"
        />
        <div
          v-if="$v.selectedInitiators.$error"
          class="mt-2 text-danger small"
        >
          {{ errorsValidation.selectedInitiators[0] }}
        </div>
      </div>
      <div class="mb-2">
        <div class="small font-weight-bold mb-1">
          Причина отмены консультации
        </div>
        <base-async-select
          :key="selectedInitiators"
          v-model="$v.selectedTransferReason.$model"
          :error="$v.selectedTransferReason.$error"
          :fetch-function="fetchTransferReasons"
          :disabled="$v.selectedInitiators.$model === null"
          placeholder="Выберите причину"
          loading-title="Загрузка"
          no-options-title="Причины не найдены"
          server-paginated
          fluid
        />
        <div
          v-if="$v.selectedTransferReason.$error"
          class="mt-2 text-danger small"
        >
          {{ errorsValidation.selectedTransferReason[0] }}
        </div>
      </div>
    </div>

    <template #modal-footer>
      <b-button
        variant="danger"
        :disabled="isCanceling"
        @click="onClose"
      >
        Отменить
      </b-button>
      <b-button
        variant="primary"
        :disabled="isCanceling"
        class="ml-2"
        @click="onClickCancel"
      >
        Удалить
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Bus from '@/eventBus';
import { showMessage } from '@/helpers/utils';
import { BaseAsyncSelect } from '@/components/base';

export default {
  name: 'ConsultationDeletingModal',
  components: {
    BaseAsyncSelect,
  },
  mixins: [validationMixin],
  props: {
    modalName: {
      type: [String, Number],
      default: null,
    },
    title: {
      type: String,
      default: 'Вы уверены, что хотите удалить консультацию?',
    },
    consultation: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isOpen: true,
      isCanceling: false,
      selectedTransferReason: null,
      selectedInitiators: null,
      initiators: [
        {
          id: 0,
          name: 'Врач',
        },
        {
          id: 1,
          name: 'Пациент',
        },
        {
          id: 2,
          name: 'Техническая ошибка',
        },
        {
          id: 3,
          name: 'Администратор',
        }],
    };
  },
  validations() {
    return {
      selectedInitiators: {
        required,
      },
      selectedTransferReason: {
        required,
      },
    };
  },
  computed: {
    errorsValidation() {
      const errors = {};

      errors.selectedTransferReason = [];
      if (!this.$v.selectedTransferReason.required) {
        errors.selectedTransferReason.push('Поле не может быть пустым');
      }

      errors.selectedInitiators = [];
      if (!this.$v.selectedInitiators.required) {
        errors.selectedInitiators.push('Поле не может быть пустым');
      }
      return errors;
    },
  },
  methods: {
    onClose() {
      this.$store.commit(this.$types.CLOSE_MODAL, { modalName: this.modalName });
    },
    async fetchTransferReasons() {
      const reasons = await this.$store.dispatch(this.$types.TRANSFER_REASONS_FETCH, this.selectedInitiators);

      return reasons.map((reason) => ({ ...reason, value: reason.id, name: reason.reason }));
    },
    async onClickCancel() {
      this.$v.$touch();

      if (this.$v.$error) {
        showMessage({
          type: 'warning',
          title: 'Ошибка валидации',
          message: 'Проверьте правильность заполнения полей',
        });

        return;
      }

      try {
        this.isCanceling = true;
        await this.$store.dispatch(this.$types.CONSULTATIONS_CANCEL, {
          consultationId: this.consultation.id,
          cancelReason: this.selectedTransferReason.id,
        });

        Bus.$emit('consultations:update', this.consultation.id);
        this.$store.commit(this.$types.PATIENT_DETAIL_CONSULATIONS_RESET);
        this.onClose();
      } finally {
        this.isCanceling = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
